import { QRCodeSVG } from 'qrcode.react'

// The join code has to be scannable from wherever people are sitting, so the
// code is sized in vw like everything else — a fixed-px QR halves in physical
// size on a 4K panel, which is exactly the failure this phase exists to avoid.
//
// `size` only writes the svg's width/height *attributes*; the className below
// overrides them in CSS and the viewBox scales the modules to match. Level "L"
// is deliberate: fewer modules for the same physical area means chunkier
// squares, and a screen-rendered code has no print noise to correct for.

interface Props {
  code: string
  /** Tailwind sizing classes for the svg — must be viewport-relative. */
  sizeClass: string
  className?: string
}

export default function JoinQr({ code, sizeClass, className }: Props) {
  const origin = typeof window === 'undefined' ? '' : window.location.origin
  const url = `${origin}/join/${code}`

  return (
    <div className={className}>
      <QRCodeSVG
        value={url}
        size={512}
        level="L"
        marginSize={2}
        // Deliberately not themed: a QR needs maximum luminance contrast to
        // scan, so this stays near-white on near-black regardless of the
        // surface it sits on.
        bgColor="#f8fafc"
        fgColor="#0a0c10"
        title={`Join ${code}`}
        className={`${sizeClass} rounded-[0.6vh] bg-[#f8fafc] shadow-raised`}
      />
    </div>
  )
}
